import { Component, OnInit, OnDestroy, OnChanges, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CatalogSectionService } from '../../catalog-section.service';
import { SmartFilterItem, CatalogFilterService } from '../../catalog-filter.service';
import { CompareService } from '../../compare/compare.service';
import { sortList } from '../../catalog-filter.component';
import {CityService} from '../../city.service';

@Component({
  selector: 'catalog-section-filter',
  templateUrl: './catalog-filter.component.html',
  styleUrls: ['./catalog-filter.component.less']
})
export class CatalogSectionFilterComponent implements OnInit, OnDestroy, OnChanges {
  @Input() filterProperties: SmartFilterItem[];
  @Input() sectionId: string;
  @Input() loadingState: boolean;
  @Output() filterChange = new EventEmitter<any>();
  @Output() orderChange = new EventEmitter<any>();
  sortOption: number = 0;
  queryCheckboxProp: object = {};
  filterCheckboxProp: object = {};
  filterPrice: [number, number] = [0, 0];
  minPrice: number;
  maxPrice: number;
  triggerTimeoutPrice: number;

  sortList = sortList;

  constructor(
    private catalogFilterService: CatalogFilterService,
    public compareService: CompareService,
    public sectionService: CatalogSectionService,
    public cityService: CityService
  ) {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.filterProperties) {
      this.queryCheckboxProp = {};
      this.filterCheckboxProp = {};
      const price = changes.filterProperties.currentValue.find((i: any) => i.CODE === 'PRICE');
      if (price) {
        this.minPrice = parseInt(price.VALUES.MIN.VALUE, 10);
        this.maxPrice = parseInt(price.VALUES.MAX.VALUE, 10);
        this.filterPrice = [this.minPrice, this.maxPrice];
      }
    }

    if (changes.sectionId) {
      this.sectionService.sections.forEach((cat) => {
        cat.SELECTED = false;
        cat.SUBSECTIONS.forEach((sec) => {
          sec.SELECTED = false;
        });
      });

      this.sectionService.sections.forEach((cat) => {
        cat.SUBSECTIONS.forEach((sec) => {
          if (sec.ID === changes.sectionId.currentValue) cat.SELECTED = true;
          else {
            sec.SUBSECTIONS.forEach((subsec) => {
              if (subsec.ID === changes.sectionId.currentValue) {
                sec.SELECTED = true;
                cat.SELECTED = true;
              }
            });
          }
        });
      });
    }
  }

  public ngOnDestroy() {
    this.sectionService.sections.forEach((cat) => {
      cat.SELECTED = false;
      cat.SUBSECTIONS.forEach((sec) => {
        sec.SELECTED = false;
      });
    });
  }

  public changeOrder() {
    if (this.sortOption) {
      this.orderChange.emit(this.sortList[this.sortOption].value);
    }
  }

  public triggerChangePrice() {
    if (this.filterPrice[0] < this.minPrice) return this.filterPrice[0] = this.minPrice;
    if (this.filterPrice[0] > (this.maxPrice - 1)) return this.filterPrice[0] = this.maxPrice - 1;
    if (this.filterPrice[1] < (this.minPrice + 1)) return this.filterPrice[1] = this.minPrice + 1;
    if (this.filterPrice[1] > this.maxPrice) return this.filterPrice[1] = this.maxPrice;

    if (typeof window !== 'undefined') {
      window.clearTimeout(this.triggerTimeoutPrice);
      this.triggerTimeoutPrice = window.setTimeout(() => {
        this.filterOut();
      }, 1000);
    }
  }

  public async changeProp(value: any) {
    if (this.queryCheckboxProp.hasOwnProperty(value.CONTROL_ID)) {
      delete this.queryCheckboxProp[value.CONTROL_ID];
    } else {
      this.queryCheckboxProp[value.CONTROL_ID] = value.HTML_VALUE;
    }

    this.filterCheckboxProp = await this.catalogFilterService.getFilter(this.sectionId, this.queryCheckboxProp);

    this.filterOut();
  }

  public filterOut() {
    const filterData: object = Object.assign({}, this.filterCheckboxProp, {'><CATALOG_PRICE_1': this.filterPrice});

    this.filterChange.emit(filterData);
  }
}
